import { render, staticRenderFns } from "./manage-list.vue?vue&type=template&id=72d2c496&scoped=true&"
import script from "./manage-list.vue?vue&type=script&lang=js&"
export * from "./manage-list.vue?vue&type=script&lang=js&"
import style0 from "./manage-list.vue?vue&type=style&index=0&id=72d2c496&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2c496",
  null
  
)

export default component.exports